import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { useSelector } from "react-redux";
import asyncComponent from "../../../util/asyncComponent";

const SmartfolioAccuracy = ({ match }) => {
  const authUser = useSelector((state) => state.auth.authUser);

  return (
    <div className="app-wrapper">
      <Switch>
        {authUser && authUser.Claims.includes("admin.access") && (
          <Redirect exact from={`${match.url}/`} to={`${match.url}/overall`} />
        )}
        {authUser && authUser.Claims.includes("admin.access") && (
          <Route
            exact
            path={`${match.url}/overall`}
            component={asyncComponent(() => import("./routes/Overall"))}
          />
        )}
        {authUser && authUser.Claims.includes("admin.access") && (
          <Route
            exact
            path={`${match.url}/signal-performance`}
            component={asyncComponent(() =>
              import("./routes/SignalPerformance")
            )}
          />
        )}
        {authUser && authUser.Claims.includes("admin.access") && (
          <Route
            exact
            path={`${match.url}/signal-constituents`}
            component={asyncComponent(() =>
              import("./routes/SignalConstituents")
            )}
          />
        )}
        {authUser && authUser.Claims.includes("admin.access") && (
          <Route
            exact
            path={`${match.url}/smartcard`}
            component={asyncComponent(() => import("./routes/SmartCardAnalysis"))}
          />
        )}
        <Route
          component={asyncComponent(() =>
            import("app/routes/extraPages/routes/404")
          )}
        />
      </Switch>
    </div>
  );
};

export default SmartfolioAccuracy;
